export default __webpack_public_path__ + "static/media/backbtn.fc442d77.svg";